import type { CSSProperties } from "react";
import { EXPERIENCE_CHAPTERS } from "../data/experience";
import { useExperienceStore } from "../store/experience-store";
import { FinaleBrand } from "./FinaleBrand";

export function StorySections(): React.JSX.Element {
  const chapterIndex = useExperienceStore((store) => store.chapterIndex);

  return (
    <>
      <main id="story" className="story" aria-label="先创紧固件数字展厅章节">
        {EXPERIENCE_CHAPTERS.map((chapter) => (
          <section
            className={`story-section story-section--${chapter.id}${
              chapter.index === chapterIndex ? " is-active" : ""
            }`}
            data-chapter={chapter.index}
            id={chapter.id}
            key={chapter.id}
          >
            <div className="story-copy">
              <p className="story-eyebrow">{chapter.eyebrow}</p>
              <h1 data-text={chapter.title} aria-label={chapter.title}>
                {chapter.title.split(" ").map((word, wordIndex) => (
                  <span className="story-word-mask" aria-hidden="true" key={`${word}-${wordIndex}`}>
                    <span
                      className="story-word"
                      style={
                        {
                          "--word-index": wordIndex,
                        } as CSSProperties
                      }
                    >
                      {word}
                    </span>
                  </span>
                ))}
              </h1>
              <span className="story-line" aria-hidden="true" />
            </div>
          </section>
        ))}
      </main>
      <FinaleBrand />
    </>
  );
}
